import {
  ChoghadiyaNames,
  dayTimeChoghadiya,
  nightTimeChoghadiya,
} from './choghadiya-table';

export const parseTimeString = (timeString: string) => {
  const [time, period] = timeString.split(' ');
  const [hours, minutes] = time.split(':');
  let parsedHours = parseInt(hours, 10);

  if (period && period.toLowerCase() === 'pm' && parsedHours !== 12) {
    parsedHours += 12;
  } else if (period && period.toLowerCase() === 'am' && parsedHours === 12) {
    parsedHours = 0;
  }

  return new Date().setHours(parsedHours, parseInt(minutes, 10), 0, 0);
};

export const addMinutesToTime = (minutes: number, timeString: string) => {
  const timeInMilliseconds = parseTimeString(timeString);

  if (isNaN(timeInMilliseconds)) {
    return 'Invalid time value';
  }

  const time = new Date(timeInMilliseconds);
  time.setMinutes(time.getMinutes() + minutes);

  const options: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };

  const formatter = new Intl.DateTimeFormat('en-US', options);
  const formattedTime = formatter.format(time);

  return formattedTime;
};

// Capitalize first character
export const normalizeLocation = (location: string) =>
  location.charAt(0).toUpperCase() + location.slice(1);

export const goodAuspiciousChoghadiya = [
  ChoghadiyaNames.amrit,
  ChoghadiyaNames.chal,
  ChoghadiyaNames.labh,
  ChoghadiyaNames.shubh,
];

export const getChoghadiyaData = (
  label: ChoghadiyaNames[],
  timingsArr: string[],
) => {
  const choghadiyaData = [];
  // iterate 8 parts
  for (let i = 0; i < 8; i++) {
    choghadiyaData[i] = {
      label: label[i],
      value: timingsArr[i] + ' - ' + timingsArr[i + 1],
    };
  }

  return choghadiyaData;
};

export const getChoghadiyaTime = (
  minutes: number,
  sunriseTime: string | undefined,
) => (sunriseTime ? addMinutesToTime(minutes, sunriseTime) : '-');

export const getLabelArr = (isNightChecked: boolean, day: number) => {
  if (isNightChecked) {
    const nightChoghadiyas = nightTimeChoghadiya[day]?.choghadiyas;
    if (nightChoghadiyas) {
      return Object.values(nightChoghadiyas);
    }
  } else {
    const dayChoghadiyas = dayTimeChoghadiya[day]?.choghadiyas;
    if (dayChoghadiyas) {
      return Object.values(dayChoghadiyas);
    }
  }
};
